import React from 'react'
import BaseIcon from './BaseIcon'

/*eslint-disable */
export default class UserPlus extends BaseIcon {
  static defaultProps = {
    width: 16,
    height: 16,
    viewBox: '0 3 16 16'
  }
  render () {
    return (
      <svg {...this.getSvgProps()}>
        <path d='M8.507 18.37c-.382.018-.722.05-1.063.047-1.072-.013-2.145-.013-3.214-.073-1.003-.054-1.997-.21-2.937-.588-.334-.136-.643-.31-.902-.566-.24-.243-.39-.534-.39-.885.01-.287-.01-.584.06-.862.12-.484.47-.83.83-1.148.59-.518 1.27-.904 1.97-1.242.44-.208.88-.39 1.33-.575.65-.265.85-1.084.39-1.615-.81-.94-1.25-2.035-1.42-3.253-.11-.8-.08-1.59.16-2.37.39-1.246 1.45-2.1 2.75-2.22.86-.076 1.66.07 2.37.578.74.525 1.14 1.267 1.31 2.14.19.96.1 1.91-.17 2.84-.25.864-.66 1.648-1.25 2.33-.186.215-.18.506-.186.78 0 .058-.01.124.01.172.086.175-.002.295-.097.437-.82 1.226-1.05 2.563-.684 3.995.176.692.507 1.31.967 1.86.05.064.1.125.18.216zm7.454-3.332c.01 2.165-1.73 3.916-3.9 3.925-2.16.01-3.92-1.754-3.92-3.925 0-2.168 1.75-3.92 3.91-3.92 2.17 0 3.91 1.752 3.92 3.92zm-3.37.57h.2c.42 0 .85-.007 1.26.002.15.003.18-.044.18-.18-.01-.27-.01-.537 0-.806.01-.117-.03-.155-.15-.155h-1.49v-1.6h-1.1v1.61H9.88v1.12h1.62v1.6h1.09v-1.6z'
          {...this.getPathProps()} />
      </svg>
    )
  }
}
/*eslint-enable */
